/**
 * This helper function allows to perform exhaustive check to enum's `switch`
 * statement that have been casted from string. It is types aid,
 * has no effect at all on anything.
 * @param _
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const exhaustiveCheckSilent = (_: never): void => {};
